import http from "../../utils/request";
import { CurrentLoginInformationsOutputDto } from "../model/CurrentLoginInformationsOutputDto";

export const getUserInfo = async (): Promise<CurrentLoginInformationsOutputDto> => {
  return await http.get<null, CurrentLoginInformationsOutputDto>("/session/currentLoginInformations");
};